"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capf6080DocumentDefinition = void 0;
var capf6080_1 = require("./capf6080");
Object.defineProperty(exports, "capf6080DocumentDefinition", { enumerable: true, get: function () { return capf6080_1.capf6080DocumentDefinition; } });
//# sourceMappingURL=index.js.map